<template>
  <a-modal
      :visible="visible"
      @update:visible="(value) => $emit('update:visible', value)"
      width="900px"
      @cancel="handleCancel"
  >
    <template #footer>
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <div v-if="currentRecord" class="change-content-modal">

      <div class="change-content-container">
        <!-- 左侧：变更前数据 -->
        <div class="change-section original-data">
          <h3>原测试牌照信息</h3>
          <div class="change-item">
            <span class="label">测试牌照：</span>
            <span class="value">{{ currentRecord.beforeData.testCarNum || '暂无数据' }}</span>
          </div>
          <div class="change-item">
            <span class="label">牌照申领日期：</span>
            <span class="value">{{ currentRecord.beforeData.plateApplyDateStr || '暂无数据' }}</span>
          </div>
          <div class="change-item">
            <span class="label">牌照到期日期：</span>
            <span class="value">{{ currentRecord.beforeData.plateExpireDateStr || '暂无数据' }}</span>
          </div>
          <div class="change-item">
            <span class="label">牌照附件：</span>
            <div class="value">
              <image-uploader
                  v-if="currentRecord.beforeData.plateAttachmentUrl"
                  :image-url="currentRecord.beforeData.plateAttachmentUrl"
                  :only-preview="true"
                  :box-width="200"
                  :box-height="120"
              />
              <span v-else>暂无附件</span>
            </div>
          </div>
        </div>

        <!-- 分隔线 -->
        <div class="separator"></div>

        <!-- 右侧：变更后数据 -->
        <div class="change-section new-data">
          <h3>新测试牌照信息</h3>
          <div class="change-item">
            <span class="label">测试牌照：</span>
            <span class="value">{{ currentRecord.afterData.testCarNum || '暂无数据' }}</span>
          </div>
          <div class="change-item">
            <span class="label">牌照申领日期：</span>
            <span class="value">{{ currentRecord.afterData.plateApplyDateStr || '暂无数据' }}</span>
          </div>
          <div class="change-item">
            <span class="label">牌照到期日期：</span>
            <span class="value">{{ currentRecord.afterData.plateExpireDateStr || '暂无数据' }}</span>
          </div>
          <div class="change-item">
            <span class="label">牌照附件：</span>
            <div class="value">
              <image-uploader
                  v-if="currentRecord.afterData.plateAttachmentUrl"
                  :image-url="currentRecord.afterData.plateAttachmentUrl"
                  :only-preview="true"
                  :box-width="200"
                  :box-height="120"
              />
              <span v-else>暂无附件</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { Modal as AModal, Button as AButton } from 'ant-design-vue';
import imageUploader from '@/components/imageUploader/index.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRecord: {
    type: Object,
    default: null
  }
});

const emits = defineEmits(['update:visible', 'cancel']);

const handleCancel = () => {
  emits('update:visible', false);
  emits('cancel');
};

const handleImageError = (event) => {
  // 图片加载失败时显示默认文本
  event.target.style.display = 'none';
  const parent = event.target.parentElement;
  if (!parent.querySelector('.error-text')) {
    const errorText = document.createElement('span');
    errorText.className = 'error-text';
    errorText.textContent = '图片加载失败';
    parent.appendChild(errorText);
  }
};
</script>

<style lang="less" scoped>
.change-content-modal {
  .change-content-container {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }

  .change-section {
    width: 45%;
  }

  .original-data {

  }

  .new-data {

  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #E1E7EF;
  }

  .change-item {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }

  .item_label {
    width: 100px;
    color: #636D7B;
    text-align: right;
    margin-right: 12px;
  }

  .item_value {
    color: #1D2129;
    flex: 1;
  }

  .separator {
    width: 1px;
    background-color: #E1E7EF;
    margin: 0 20px;
    height: 150px;
    align-self: center;
  }

  .plate-image {
    max-width: 300px;
    max-height: 120px;
    border: 1px solid #E1E7EF;
    border-radius: 4px;
    margin-top: 0;
    vertical-align: top;
  }

  .error-text {
    color: #FF4D4F;
    font-size: 12px;
  }
}
</style>